module.exports = __webpack_public_path__ + "static/img/bg-en.36982f42.png";